import { guard } from "effector";
import { audioEnded } from "../domain/audio";
import { $playerHasNextTrack } from "../domain/player-track-queue";
import { $isTimetableInterruptionPlaying } from "frontend/src/features/play-timetable-interruptions";
import { tryPlayNextTrackInQueue } from "../features/play-track-from-queue";
guard({
    clock: audioEnded,
    source: {
        playerHasNextTrack: $playerHasNextTrack,
        isTimetableInterruptionPlaying: $isTimetableInterruptionPlaying,
    },
    filter: function (_a) {
        var playerHasNextTrack = _a.playerHasNextTrack, isTimetableInterruptionPlaying = _a.isTimetableInterruptionPlaying;
        return playerHasNextTrack && !isTimetableInterruptionPlaying;
    },
    target: tryPlayNextTrackInQueue,
});
